export const TITLES = [
  {
    title: "Human Hunters",
    tagline: "The Famous Monsters Hunt the Worst of Humanity - Issue #4",
    badge: "NEW ISSUE #4",
    cover: "/covers/human-hunters-4.jpg",
    tags: ["new"],
  },
  {
    title: "Ninja Bimbos",
    tagline: "Lethal Katana Kisses & 90s Action",
    badge: "NEW ISSUE #3",
    cover: "/covers/ninja-bimbos-3.jpg",
    tags: ["new"],
  },
  {
    title: "Dark America",
    tagline: "Visceral Dystopian Graphic Novel",
    badge: "UNCENSORED",
    cover: "/covers/dark-america.jpg",
    tags: ["uncensored"],
  },
  {
    title: "Mary Machinegun",
    tagline: "High-Caliber Vengeance, Blessed in Blood",
    badge: "FAN BESTSELLER",
    cover: "/covers/mary-issue-1-reloaded.png",
    tags: ["bestseller"],
  },
];

export const GALLERY = [
  { src: "/covers/mary-issue-2-sfw.png", title: "Mary Machinegun #2", artist: "Atrocity Comix" },
  { src: "/covers/mary-valkyrie.jpg", title: "Mary Machinegun — Valkyrie", artist: "Atrocity Comix" },
  { src: "/covers/mary-issue-4.png", title: "Mary Machinegun #4", artist: "Atrocity Comix" },
  { src: "/covers/human-hunters-4.jpg", title: "Human Hunters #4", artist: "Reed, Devill & Duarte" },
  { src: "/covers/mary-tpb-sfw.png", title: "Mary Machinegun Trade Paperback", artist: "Atrocity Comix" },
  { src: "/covers/dark-america.jpg", title: "Dark America", artist: "Atrocity Comix" },
  { src: "/covers/ninja-bimbos-3.jpg", title: "Ninja Bimbos #3 Cover", artist: "John Stinsman — Atrocity Comix" },
  { src: "/covers/mary-machinegun-orange.webp", title: "Mary Machinegun — Justin Hunt", artist: "Atrocity Comix" },
  { src: "/covers/human-hunters-1-halloween.webp", title: "Human Hunters #1 — Halloween Special", artist: "Johnnie Reed & Max Devill" },
];

export const TESTIMONIALS = [
  {
    quote: "Atrocity Comix is a wild ride — each page is a mix of humor and action that leaves me wanting more!",
    author: "William Skylar",
    role: "Comic Buff & Collector",
  },
  {
    quote: "Finally, a press with teeth. Mary Machinegun is the bad girl comic the 90s always deserved.",
    author: "Roxy Delgado",
    role: "Zine Reviewer",
  },
  {
    quote: "Bought the physical, bought the digital, bought the print. No regrets. My longbox is dangerous now.",
    author: "Marcus Kane",
    role: "Longbox Loyalist",
  },
];
